import { requestGet } from '@/common/request';

interface MarketingPlanListType {
  status: 1 | 2 | 3 | 4;
  currentPage: number;
  pageSize: number;
  simpleQuery: boolean;
}

interface MarketingPlan {
  totalPage: number;
  pageSize: number;
  currentPage: number;
  totalCount: number;
  list: {
    id: 1;
    code: string;
    name: string;
    status: number;
    total: number;
    complete: string;
    btn: ('detail' | 'update' | 'del' | 'download')[];
  }[];
}

export default async function marketingPlanDel(query: MarketingPlanListType): Promise<RequestResult<MarketingPlan>> {
  return await requestGet('/marketingPlan/list', query);
}
